import { TYPES } from '../../action-types/bill-to-party';
import { IBillToPartyState, IBillToPartyAction } from './model';
import { formatPartners, formatCustomers } from './logic';

export const defaultState: IBillToPartyState = {
	partners: null,
	partnersRawData: [],
	customers: null,
	customersRawData: [],
	errors: [],
};

export const reducer = (state: IBillToPartyState = defaultState, action: IBillToPartyAction) => {
	switch (action.type) {
		case TYPES.FETCH_ALL_BILL_TO_PARTIES_PENDING:
			return {
				partners: null,
				customers: null,
				errors: [],
			};
		case TYPES.FETCH_ALL_BILL_TO_PARTIES_PARTIAL_SUCCESS:
			return {				
				partnersRawData: action.payload?.partners,
				partners: action.payload?.partners ? formatPartners(action.payload.partners) : null,				
				customersRawData: action.payload?.customers,
				customers: action.payload?.customers ? formatCustomers(action.payload.customers) : null,
				errors: [],
			};
		case TYPES.FETCH_ALL_BILL_TO_PARTIES_SUCCESS:
			return {
				partnersRawData: action.payload?.partners,
				partners: action.payload?.partners ? formatPartners(action.payload.partners) : null,
				customersRawData: action.payload?.customers,
				customers: action.payload?.customers ? formatCustomers(action.payload.customers) : null,				
				errors: action.payload?.errors,
			};
		case TYPES.FETCH_ALL_BILL_TO_PARTIES_ERROR:
			return {
				partners: null,
				customers: null,
				errors: action.payload?.errors,
			};
		case TYPES.RESET_ALL_BILL_TO_PARTIES_ERROR:
			return {
				partners: null,
				customers: null,
				errors: [],
			};
		default:
			return state;
	}
};